// extracted by mini-css-extract-plugin
module.exports = {"group":"widget-demo--group--NW7DN","title":"widget-demo--title--X7n9M","list":"widget-demo--list--2fWWL","listNonVirtualized":"widget-demo--listNonVirtualized--3fm-m"};